import { action, computed, observable, makeAutoObservable } from 'mobx';
import { LocalStorageState } from 'src/AppState/LocalStorageState/LocalStorageState';

export class EventPageState {
    @observable openedEvents: Array<number> = [];
    @observable recentlyViewed: Array<number> = [];

    constructor(readonly localStorage: LocalStorageState) {
        this.recentlyViewed = this.localStorage.recentlyEvents.getValue();
        makeAutoObservable(this);
    }

    @computed get savedEventsCount(): number {
        return this.openedEvents.length;
    }
    @computed get lastEvent(): number | undefined {
        return this.openedEvents[this.openedEvents.length - 1];
    }

    @action addEvent = (eventId: number): void => {
        if (this.openedEvents.includes(eventId) === false) {
            this.openedEvents.push(eventId);
        }
    };

    @action removeEvent = (eventId: number): void => {
        this.openedEvents = this.openedEvents.filter((event) => event !== eventId);
    };

    @action addToRecentlyViewed = (eventId: number): void => {
        const index = this.recentlyViewed.indexOf(eventId);
        if (index !== -1) {
            const id = this.recentlyViewed.splice(index, 1);
            this.recentlyViewed = [...id, ...this.recentlyViewed];
        } else {
            if (this.recentlyViewed.length >= 5) {
                this.recentlyViewed.pop();
                this.recentlyViewed.unshift(eventId);
            } else {
                this.recentlyViewed.unshift(eventId);
            }
        }

        this.localStorage.recentlyEvents.setValue(this.recentlyViewed);
    };
}
